/**
 * Libraries
 */

import * as Sentry from '@sentry/vue';

/**
 * Types
 */

import type { App } from 'vue';
import type { Router } from 'vue-router';

const rate = (value: string | undefined) => Number(value) || 0;

function setupSentry(app: App<Element>, router: Router) {
  const env = import.meta.env;
  const replaysSessionSampleRate = rate(
    env.VITE_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
  );
  const replaysOnErrorSampleRate = rate(
    env.VITE_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
  );
  const replayEnabled =
    replaysSessionSampleRate > 0 || replaysOnErrorSampleRate > 0;
  const maskReplay = env.VITE_APP_SENTRY_REPLAY_MASK !== 'false';

  Sentry.init({
    app,
    dsn: env.VITE_APP_SENTRY_DSN,
    environment: env.VITE_APP_SENTRY_ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      ...(replayEnabled
        ? [
            Sentry.replayIntegration({
              maskAllText: maskReplay,
              blockAllMedia: maskReplay,
            }),
          ]
        : []),
    ],
    tracePropagationTargets: [env.VITE_APP_API_URL],
    tracesSampleRate: rate(env.VITE_APP_SENTRY_TRACES_SAMPLE_RATE),
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
  });

  Sentry.setTag('tenant', env.VITE_APP_TENANT);
}

export { setupSentry };
